import { render, staticRenderFns } from "./Rateplans.vue?vue&type=template&id=7c0bd2de&"
import script from "./Rateplans.vue?vue&type=script&lang=js&"
export * from "./Rateplans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports